module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel live-session",
    class: {
      'sidebar-widget': _vm.location === 'sidebar'
    }
  }, [_vm._v("\n     " + _vm._s(_vm.date) + "\n     "), _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_c('img', {
    attrs: {
      "src": require("../../assets/img/live-qa-icon.png")
    }
  }), _vm._v("Next Live Session"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Your next live session countdown.'),
      expression: "'Your next live session countdown.'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })])]), _vm._v(" "), (_vm.isOngoing || _vm.meetings || _vm.nextGlobalMeeting) ? _c('div', {
    staticClass: "panel-body"
  }, [(_vm.nextMeeting && _vm.nextMeeting !== Infinity && (_vm.noUpcomingMeeting == false || _vm.isOngoing)) ? _c('div', {
    staticClass: "next-meeting"
  }, [(!_vm.isPastSemester) ? _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm._f("longDate")(_vm.nextMeeting.startTime)))]) : _vm._e(), _vm._v(" "), (_vm.nextMeeting.name) ? _c('span', {
    staticClass: "meeting-name"
  }, [_vm._v(_vm._s(_vm.nextMeeting.name))]) : _c('span', {
    staticClass: "meeting-name"
  }, [_vm._v("Live Session")]), _vm._v(" "), (!_vm.isPastSemester &&
    !_vm.localStorage.roles.includes('CampusStudent') &&
    _vm.localStorage.transitioned != 'true'
  ) ? _c('div', {
    staticClass: "countdown"
  }, [(!_vm.isOngoing) ? _c('countdown', {
    attrs: {
      "duration": _vm.nextMeeting.duration,
      "date": _vm.nextMeeting.startTime,
      "isForMeeting": true
    }
  }) : _c('span', {
    staticClass: "countdown"
  }, [_c('span', {
    staticClass: "join-session"
  }, [_vm._v("Join Session")])]), _vm._v(" "), (_vm.isAvailable(_vm.nextMeeting.startTime)) ? _c('a', {
    staticClass: "join",
    attrs: {
      "href": _vm.nextMeeting.joinUrl,
      "target": "_blank"
    },
    on: {
      "mousedown": function($event) {
        _vm.recordAttendance(_vm.nextMeeting)
      }
    }
  }, [_vm._v("Join")]) : _c('a', {
    staticClass: "join disabled",
    attrs: {
      "href": _vm.nextMeeting.joinUrl,
      "target": "_blank"
    }
  }, [_vm._v("\n                         Join\n                     ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.isPastSemester &&
    (_vm.localStorage.roles.includes('CampusStudent') ||
      _vm.localStorage.transitioned == 'true')) ? _c('div', {
    staticClass: "countdown"
  }, [(_vm.isOngoing !== true) ? _c('countdown', {
    attrs: {
      "duration": _vm.nextMeeting.duration,
      "isForMeeting": true,
      "date": _vm.nextMeeting.startTime
    }
  }) : _vm._e(), _vm._v(" "), (_vm.nextMeeting.zoomId) ? _c('div', [(_vm.isAvailable(_vm.nextMeeting.startTime)) ? _c('a', {
    staticClass: "join",
    attrs: {
      "href": _vm.nextMeeting.joinUrl,
      "target": "_blank"
    },
    on: {
      "mousedown": function($event) {
        _vm.recordAttendance(_vm.nextMeeting)
      }
    }
  }, [_vm._v("Join")]) : _c('a', {
    staticClass: "join disabled",
    attrs: {
      "href": _vm.nextMeeting.joinUrl,
      "target": "_blank"
    }
  }, [_vm._v("\n                             Join\n                         ")])]) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), ((!_vm.nextMeeting || _vm.nextMeeting === Infinity) && _vm.noUpcomingMeeting === true && !_vm.nextGlobalMeeting) ? _c('div', [_c('div', {
    staticClass: "next-meeting text-center"
  }, [_vm._v("\n                 No Meetings scheduled\n             ")])]) : _vm._e(), _vm._v(" "), (_vm.nextGlobalMeeting && _vm.location === 'sidebar') ? _c('div', {
    staticClass: "next-meeting next-global-meeting"
  }, [(!_vm.isPastSemester) ? _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm._f("longDate")(_vm.nextGlobalMeeting.startTime)) + "\n             ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "meeting-name",
    on: {
      "click": function($event) {
        _vm.selectedGlobalMeeting = _vm.nextGlobalMeeting
      }
    }
  }, [_vm._v("\n                     " + _vm._s(_vm.nextGlobalMeeting.name) + " "), _c('br'), _vm._v(" (" + _vm._s(_vm.nextGlobalMeeting.global_meeting_participants.length) + " / " + _vm._s(_vm.nextGlobalMeeting.maxParticipants) + ")\n             ")]), _vm._v(" "), (!_vm.isPastSemester &&
    !_vm.localStorage.roles.includes('CampusStudent')) ? _c('div', {
    staticClass: "countdown"
  }, [(!_vm.ongoingMeeting(_vm.nextGlobalMeeting.startTime)) ? _c('countdown', {
    attrs: {
      "duration": _vm.nextGlobalMeeting.duration,
      "date": _vm.nextGlobalMeeting.startTime,
      "isForMeeting": true
    }
  }) : _c('span', {
    staticClass: "countdown"
  }, [_c('span', {
    staticClass: "join-session"
  }, [_vm._v("Join Session")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [(!_vm.isWaitListed(_vm.nextGlobalMeeting)) ? _c('span', [(_vm.isAvailable(_vm.nextGlobalMeeting.startTime)) ? _c('a', {
    staticClass: "join",
    attrs: {
      "href": _vm.nextGlobalMeeting.joinUrl,
      "target": "_blank"
    },
    on: {
      "mousedown": function($event) {
        _vm.recordAttendance(_vm.nextGlobalMeeting)
      }
    }
  }, [(_vm.nextGlobalMeeting.mentor.id == _vm.localStorage.user_id) ? _c('span', [_vm._v("Start")]) : _c('span', [_vm._v("Join")])]) : _c('a', {
    staticClass: "join disabled",
    attrs: {
      "href": _vm.nextGlobalMeeting.joinUrl,
      "target": "_blank"
    }
  }, [(_vm.nextGlobalMeeting.mentor.id == _vm.localStorage.user_id) ? _c('span', [_vm._v("Start")]) : _c('span', [_vm._v("Join")])])]) : _vm._e(), _vm._v(" "), (_vm.nextGlobalMeeting.mentor.id != _vm.localStorage.user_id) ? _c('button', {
    staticClass: "opt-out btn btn-danger",
    class: {
      'disabled': _vm.optOutCutoffPassed
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.optOut(_vm.nextGlobalMeeting.id)
      }
    }
  }, [_vm._v("\n                             Opt Out\n                     ")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (!_vm.isPastSemester && _vm.localStorage.roles.includes('CampusStudent')) ? _c('div', {
    staticClass: "countdown"
  }, [(_vm.isOngoing !== true) ? _c('countdown', {
    attrs: {
      "isForMeeting": true,
      "duration": _vm.nextGlobalMeeting.duration,
      "date": _vm.nextGlobalMeeting.startTime
    }
  }) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.selectedGlobalMeeting) ? _c('div', [(_vm.roles.includes('GlobalMentor') || _vm.roles.includes('Recruiter')) ? _c('global-meeting-participants', {
    attrs: {
      "participants": _vm.selectedGlobalMeeting.global_meeting_participants,
      "link": _vm.selectedGlobalMeeting.joinUrl,
      "recordingProcessing": false,
      "hasRecording": false,
      "maxParticipants": _vm.selectedGlobalMeeting.maxParticipants
    },
    on: {
      "closeModal": function($event) {
        _vm.selectedGlobalMeeting = null
      }
    }
  }) : _c('global-meeting-signup', {
    attrs: {
      "meetingId": _vm.selectedGlobalMeeting.id
    },
    on: {
      "closeModal": function($event) {
        _vm.selectedGlobalMeeting = null
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.location !== 'sidebar') ? _c('VuePerfectScrollbar', {
    staticClass: "scroll-area next-live-session"
  }, [_c('ul', {
    staticClass: "archives"
  }, _vm._l((_vm.meetings), function(meeting, index) {
    return (_vm.isInPast(meeting.startTime, meeting.duration)) ? _c('li', {
      staticClass: "clearfix"
    }, [_c('div', {
      staticClass: "col-xs-6"
    }, [_vm._v("\n                         Week " + _vm._s(_vm.meetingWeek(meeting.startTime)) + "\n                     ")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6 text-right"
    }, [(!meeting.archiveUrl) ? _c('a', {
      staticClass: "no-archive"
    }, [_vm._v("No Archive")]) : _vm._e(), _vm._v(" "), (meeting.archiveUrl && meeting.archiveStatus === 'processing') ? _c('a', {
      staticClass: "processing"
    }, [_vm._v("\n                             Archive Processing\n                         ")]) : _vm._e(), _vm._v(" "), (meeting.archiveUrl && meeting.archiveStatus === 'completed') ? _c('div', {
      attrs: {
        "href": meeting.archiveUrl,
        "target": "_blank"
      }
    }, [_c('a', {
      attrs: {
        "href": meeting.archiveUrl,
        "target": "_blank"
      }
    }, [_vm._v("Live Session Archive")]), _vm._v(" "), (meeting.secondaryRecordings && meeting.secondaryRecordings.length > 0) ? _c('span', [_vm._v("\n                                 (\n                                 "), _c('a', {
      attrs: {
        "href": meeting.archiveUrl,
        "target": "_blank"
      }
    }, [_vm._v("1")]), _vm._v(" "), _vm._l((meeting.secondaryRecordings), function(recording, index) {
      return _c('span', [_vm._v(",\n                                     "), _c('a', {
        attrs: {
          "href": recording,
          "target": "_blank"
        }
      }, [_vm._v(" " + _vm._s(index + 2) + " ")])])
    }), _vm._v(")\n                             ")], 2) : _vm._e()]) : _vm._e()])]) : _vm._e()
  }))]) : _vm._e()], 1) : _c('div', {
    staticClass: "panel-body text-center"
  }, [_c('p', [_vm._v("No meetings scheduled yet")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5559bdfd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/NextLiveSession.vue
// module id = 2048
// module chunks = 2